import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import eventBus from './utils/eventBus'

// 修改Element Plus的导入方式
// import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'

// 引入全局样式
import './styles/global.css'

// 图标单独导入，避免初始化顺序问题
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 创建应用实例
const app = createApp(App)

// 先使用其他插件
app.use(createPinia())
app.use(router)

// 然后配置Element Plus，添加中文语言包
// app.use(ElementPlus, {
//   locale: zhCn,
//   size: 'default',
//   zIndex: 3000
// })

// 最后注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 添加全局属性
app.config.globalProperties.$bus = eventBus

// 关闭调试模式
app.config.productionTip = false
app.config.devtools = false
app.config.debug = false
app.config.silent = true

// 注释掉或删除调试插件
// import RouteDebugger from 'vue-route-debugger' // 或类似名称
// Vue.use(RouteDebugger)

// 在生产环境中禁用控制台输出
if (process.env.NODE_ENV === 'production') {
  // 保留错误输出，方便调试
  const originalConsoleError = console.error;
  console.log = () => {}
  console.warn = () => {}
  console.error = (...args) => {
    // 检查是否是我们关注的错误
    const errorString = args.join(' ');
    if (errorString.includes('Cannot access') || errorString.includes('dt')) {
      originalConsoleError(...args);
    }
  }
}

// 添加全局样式来隐藏调试面板
const style = document.createElement('style');
style.innerHTML = `
  .debug-panel, .route-info, .debug-info, [class*="debug"] {
    display: none !important;
  }
`;
document.head.appendChild(style);

// 创建一个全局指令来移除调试面板
app.directive('remove-debug', {
  mounted(el) {
    const debugPanels = el.querySelectorAll('.debug-panel, .route-info, .debug-info, [class*="debug"]');
    debugPanels.forEach(panel => {
      if (panel && panel.parentNode) {
        panel.parentNode.removeChild(panel);
      }
    });
  }
});

// 在根元素上使用这个指令
const appElement = document.getElementById('app');
if (appElement) {
  appElement.setAttribute('v-remove-debug', '');
}

// 挂载应用
app.mount('#app') 